export enum TOAST_MESSAGE_STATUS {
	TOAST_SUCCESS = 'success',
	TOAST_CONFLICT_ERROR = 'conflict',
	TOAST_ERROR = 'error',
}
